import { Button } from '~ui/base/button';
import { Typography } from '~ui/base/typography';

interface SearchEmptyProps {
  query: string;
  onClear: () => void;
}

/** Empty state — single line of guidance, single secondary recovery button. */
function SearchEmpty({ query, onClear }: SearchEmptyProps) {
  return (
    <div className="flex flex-col items-start gap-y-3">
      <Typography variant="headline-sm" as="h2" className="text-foreground">
        No datasets match <span className="text-primary">“{query}”</span>
      </Typography>
      <Typography variant="body-md" as="p" className="text-muted-foreground-dark">
        Try a broader term, or check the spelling.
      </Typography>
      <Button variant="secondary" size="md" onClick={onClear}>
        Clear search
      </Button>
    </div>
  );
}

export { SearchEmpty };
